import RFFInputField from '../../components/form/RFFInputField';
import RFFMultiSelectField from '../../components/form/RFFMultiSelect/RFFSelect';
import RFFRadio from '../../components/form/RFFRadio';
// import RFFSelectField from '../../components/form/RFFSelect/RFFSelect';
import AdditiveManufacturingCapabilities from '../../config/additiveManufacturingCapabilities.json';
import AdditionalCapabilities from '../../config/additionalCapabilities.json';
import ApprovedSource from '../../config/approvedSource.json';
import AssemblyMethods from '../../config/assemblyMethods.json';
import BusinessClassifications from '../../config/businessClassifications.json';
import CastingProcess from '../../config/castingProcess.json';
import CoreProcess from '../../config/coreProcess.json';
import FlaskSize from '../../config/flaskSize.json';
import FederalClassification from '../../config/federalClassifications.json';
import ForgingProcess from '../../config/forgingProcess.json';
import HeatRange from '../../config/heatRange.json';
import IndustriesServed from '../../config/industriesServed.json';
import MachiningEnvelope from '../../config/machiningEnvelope.json';
import MachiningMethods from '../../config/machiningMethods.json';
import MachiningServices from '../../config/machiningServices.json';
import MoldCastingProcess from '../../config/moldCastingProcess.json';
import NonDestructiveTesting from '../../config/nonDestructiveTesting.json';
import Certifications from '../../config/qualityCertifications.json';
import SecondaryOperations from '../../config/SecondaryOperations.json';
import SurfaceTreatments from '../../config/surfaceTreatments.json';

const rapidToolingOptions = {
  fdm: 'Fused Deposition Modeling (FDM)',
  lom: 'Laminated Object Manufacturing (LOM)',
  sls: 'Selective Laser Sintering (SLS)',
  sgc: 'Solid Ground Curing (SGC)',
  sla: 'Stereolithography (SLA)',
  ded: 'Directed Energy Deposition (DED)',
  dmls: 'Direct Metal Laser Sintering (DMLS)',
  pbf: 'Powder Bed Fusion (PBF)'
};

const createOptions = obj => {
  const objKeys = Object.keys(obj);
  return objKeys.map(key => ({ text: obj[key], value: key }));
};

export const SupplierProfileFieldsLeft = [
  {
    name: 'company',
    label: 'Company Name',
    component: RFFInputField,
    disabled: true,
  },
  {
    name: 'componentWeight',
    label: 'Maximum Component Weight',
    component: RFFInputField,
    placeholder: 'Enter component weight',
  },
];

export const SupplierProfileFieldsRight = [
  {
    name: 'cage',
    label: 'Cage Code',
    component: RFFInputField,
    labelCol: { md: 3 },
    disabled: true,
  },
  {
    name: 'lowVolume',
    label: 'Low Volume',
    component: RFFRadio,
    options: [
      {
        text: 'Yes',
        value: true,  // Changed to boolean
      },
      {
        text: 'No',
        value: false,  // Changed to boolean
      },
    ],
  },
  {
    name: 'simulationCapability',
    label: 'Simulation Capability',
    component: RFFRadio,
    options: [
      {
        text: 'Yes',
        value: true,  // Changed to boolean
      },
      {
        text: 'No',
        value: false,  // Changed to boolean
      },
    ],
  },
];

export const ClassificationsAndCapsFieldsLeft = [
  {
    name: 'additiveManufacturingCapabilities',
    label: 'Additive Manufacturing',
    component: RFFMultiSelectField,
    options: createOptions(AdditiveManufacturingCapabilities),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'additionalCapabilities',
    label: 'Additional Capabilities',
    component: RFFMultiSelectField,
    options: createOptions(AdditionalCapabilities),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'approvedSource',
    label: 'Approved Source',
    component: RFFMultiSelectField,
    options: createOptions(ApprovedSource),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'assemblyMethods',
    label: 'Assembly Methods',
    component: RFFMultiSelectField,
    options: createOptions(AssemblyMethods),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'bizClass',
    label: 'Business Classifications',
    component: RFFMultiSelectField,
    options: createOptions(BusinessClassifications),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'castings',
    label: 'Casting Process',
    component: RFFMultiSelectField,
    options: createOptions(CastingProcess),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'coreProcesses',
    label: 'Core Process',
    component: RFFMultiSelectField,
    options: createOptions(CoreProcess),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'dimensionCapability',
    label: 'Dimension Capability',
    component: RFFMultiSelectField,
    options: createOptions(FlaskSize),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'forgingProcesses',
    label: 'Forging Process',
    component: RFFMultiSelectField,
    options: createOptions(ForgingProcess),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'fsc',
    label: 'Federal Classification',
    component: RFFMultiSelectField,
    mode: 'multiple',
    defaultValue: [],
    key: 'fsc',
    options: createOptions(FederalClassification),
  }
];

export const ClassificationsAndCapsFieldsRight = [
  {
    name: 'heatCapacity',
    label: 'Heat Capacity',
    component: RFFMultiSelectField,
    options: createOptions(HeatRange),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'industriesServed',
    label: 'Industries Served',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(IndustriesServed),
    mode: 'multiple',
  },
  {
    name: 'machiningEnvelope',
    label: 'Machining Envelope',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(MachiningEnvelope),
    mode: 'multiple',
  },
  {
    name: 'machiningMethods',
    label: 'Machining Methods',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(MachiningMethods),
    mode: 'multiple',
  },
  {
    name: 'machiningServices',
    label: 'Machining Services',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(MachiningServices),
    mode: 'multiple',
  },
  {
    name: 'moldCastingProcess',
    label: 'Mold Casting Process',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(MoldCastingProcess),
    mode: 'multiple',
  },
  {
    name: 'nonDestructiveTesting',
    label: 'Non-Destructive Testing',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(NonDestructiveTesting),
    mode: 'multiple',
  },
  {
    name: 'qualityCerts',
    label: 'Quality Certifications',
    component: RFFMultiSelectField,
    options: createOptions(Certifications),
    mode: 'multiple',
    defaultValue: [],
  },
  {
    name: 'rapidTooling',
    label: 'Rapid Tooling',
    component: RFFMultiSelectField,
    options: createOptions(rapidToolingOptions),
    defaultValue: [],
    mode: 'multiple',
    allowClear: true,
  },
  {
    name: 'secondaryOperations',
    label: 'Secondary Operations',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(SecondaryOperations),
    mode: 'multiple',
  },
  {
    name: 'surfaceTreatments',
    label: 'Surface Treatments',
    component: RFFMultiSelectField,
    defaultValue: [],
    options: createOptions(SurfaceTreatments),
    mode: 'multiple',
  }
];



// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/formConfig.jsx